const handleError = (id: number, fieldType: 'presence' | 'borrowHelmet') => {
  const field = document.getElementById(
    `${fieldType}[${id.toString()}]`
  ) as HTMLInputElement | null;

  if (field) {
    field.checked = !field.checked;
  }

  alert('Sorry, we konden deze actie niet uitvoeren. Probeer het opnieuw.');
};

const submit = (id: number | null, checked: boolean, fieldType: 'presence' | 'borrowHelmet') => {
  if (!id) {
    return;
  }

  const fetchHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-CSRF-Token': window.csrfTokenValue,
  };
  const eventId = window.currentEvent.id;
  const formData = new FormData();
  formData.append('eventId', eventId.toString());
  formData.append('participantId', id.toString());
  formData.append(fieldType, checked ? '1' : '0');

  if (fieldType === 'presence') {
    fetch('/api/activities/dbr/organize/toggle-presence', {
      method: 'POST',
      headers: fetchHeaders,
      body: JSON.stringify(Object.fromEntries(formData.entries())),
    })
      .then((response) => response.json())
      .catch(() => {
        handleError(id, 'presence');
      });
  }

  if (fieldType === 'borrowHelmet') {
    fetch('/api/activities/dbr/organize/toggle-borrow-helmet', {
      method: 'POST',
      headers: fetchHeaders,
      body: JSON.stringify(Object.fromEntries(formData.entries())),
    })
      .then((response) => response.json())
      .catch(() => {
        handleError(id, 'borrowHelmet');
      });
  }
};

const getUserId = (fieldName: string) => {
  const match = /\[(\d+)\]/.exec(fieldName);

  return match ? parseInt(match[1], 10) : null;
};

export const manageSubmissions = () => {
  const borrowHelmets: NodeListOf<HTMLInputElement> = document.querySelectorAll(
    'input[id^="borrowHelmet"]'
  );
  const presence: NodeListOf<HTMLInputElement> = document.querySelectorAll('input[id^="presence"]');

  borrowHelmets.forEach((borrowHelmet): void => {
    borrowHelmet.addEventListener('change', () => {
      submit(getUserId(borrowHelmet.name), borrowHelmet.checked, 'borrowHelmet');
    });
  });

  presence.forEach((presenceInput) => {
    presenceInput.addEventListener('change', () => {
      submit(getUserId(presenceInput.name), presenceInput.checked, 'presence');
    });
  });
};
